import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GuestService, { GuestKpis, GuestOrderRow } from "@/app/_services/GuestService";
import { toast } from "@/app/_utils/toast";

export type GuestDetailData = {
  guest: any;
  kpis: GuestKpis;
  orders: GuestOrderRow[];
};

export function useGuestDetailModel() {
  const { guest_id } = useParams<{ guest_id: string }>();
  const [data, setData] = useState<GuestDetailData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  async function load() {
    if (!guest_id) return;
    setIsLoading(true);
    try {
      const [guest, kpis, orders] = await Promise.all([
        GuestService.getGuest(guest_id),
        GuestService.getGuestKpis(guest_id),
        GuestService.getGuestOrders(guest_id),
      ]);
      setData({ guest, kpis, orders });
    } catch {
      toast.error("Failed to load guest");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guest_id]);

  return { data, isLoading, refetch: load };
}
